import { FeatureCode } from '../../apiClient/customer-profile/features';
export const getIdentity = (user, features) => {
    const userFeatures = features.enabledFeatures;
    const featureSet = {
        featureQRScanning: userFeatures.includes(FeatureCode.QRSCANNING),
        featureEscalations: userFeatures.includes(FeatureCode.ESCALATIONS),
        featureOperationalInsight: userFeatures.includes(FeatureCode.OPERATIONAL_INSIGHTS),
        featureDateEntryCheck: userFeatures.includes(FeatureCode.DATE_ENTRY_CHECK),
        featureIOTStack: userFeatures.includes(FeatureCode.HUB_USE_AWS_IOT_STACK),
        featureZigbeeMiscomAlert: userFeatures.includes(FeatureCode.SENSOR_MISCOMS_ALERTS),
        featurePhotoUpload: userFeatures.includes(FeatureCode.PHOTO_UPLOAD),
        featureManualTemperature: userFeatures.includes(FeatureCode.MANUAL_TEMPERATURE),
        featureAmAlertsOnMemo: userFeatures.includes(FeatureCode.AM_ALERTS_ON_MEMO),
        featureHubUseHttps: userFeatures.includes(FeatureCode.HUB_USE_HTTPS),
        featureMemoUseIot: userFeatures.includes(FeatureCode.MEMO_USE_AWS_IOT_STACK)
    };
    return Object.assign({
        customerName: user.customer.name,
        hasAutomatedMonitoring: user.modules.automatedMonitoring,
        hasWorkManagement: user.modules.workManagement,
        isAdministrator: user.roles.administrator,
        isSafetyManager: user.roles.safetyManager,
        isSupervisor: user.roles.supervisor,
    }, featureSet);
};
//# sourceMappingURL=trackingUtlis.js.map